import CreateCoachingSessionViewContainer from './CreateCoachingSessionViewContainer';
export default CreateCoachingSessionViewContainer;
